import React from 'react';
import ReportHeatmapTable from "../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";

const EventByWeekDay = ({ data }) => {
    if (!data || data.length <= 0) return null;

    return (
        <>
            <ReportHeatmapTable
                data={data ?? []}
                title="Eventos por dia da semana"
                sheetName="Eventos por dia da semana"
                tableId="event-by-week-day"
            />
        </>
    );
};

export default EventByWeekDay;